// 招商审核
import store from '@/store';
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtnText: '新增招商码',
  addTitle: '新增招商码',
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchSpan:6,
  searchLabelWidth: 100,
  border: true,
  index: false,
  menu: true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    // {
    //   label: '代理商简称',
    //   prop: 'businessDeptIdList',
    //   type: 'select',
    //   filterable: true,
    //   searchMultiple: true,
    //   searchClearable: true,
    //   search:true,
    //   hide: true,
    //   searchOrder: 1000,
    //   minWidth:120,
    //   dicData: store.getters.companies,
    //   props: {
    //     label: 'title',
    //     value: 'id',
    //   },
    // },
    {
      label: '代理商简称',
      prop: 'agentShortName',
      minWidth:120,
      type: 'input',
      search: true
    },
    {
      label: '代理商全称',
      prop: 'agentFullName',
      minWidth:180,
      type: 'input',
    },
    {
      label: '开通产品',
      prop: 'rentType',
      type: 'select',
      search:true,
      // searchOrder: 999,
      dicData: store.getters.porductTypes,
    },
    {
      label: '申请日期',
      prop: 'createTime',
      minWidth:180,
      type: 'input',
    },
    {
      label: '招商经理',
      prop: 'managerName',
      minWidth:180,
      type: 'input',
    },
    {
      label: 'GPS套数',
      prop: 'gpsNum',
      type: 'input',
    },
  ],
};
